module.exports = "<p>\r\n  fichas works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/fichas/fichas.component.html
// module id = ../../../../../src/app/components/fichas/fichas.component.html
// module chunks = main